import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _h;
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Switch } from '@crehana/compass.ui';
import { Button } from '@crehana/compass.ui/button';
import { customSessionStorage } from '@crehana/utils';
import { isProduction } from "../../constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DebuggerContext = /*#__PURE__*/createContext(undefined);
export var useDebugger = function useDebugger() {
  var context = useContext(DebuggerContext);
  if (context === undefined) {
    throw new Error('useDebugger must be used within a DebuggerProvider');
  }
  return context;
};
var initialState = {
  shouldFilter: true,
  sidebarVersion: 'v1',
  showHRISLinks: false
};
export var DebuggerProvider = function DebuggerProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  var switchConfigs = [{
    id: 'sidebar-version',
    label: 'New version?',
    checked: state.sidebarVersion === 'v2',
    onChange: function onChange() {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          sidebarVersion: prev.sidebarVersion === 'v1' ? 'v2' : 'v1'
        });
      });
    }
  }, {
    id: 'should-filter',
    label: 'Filter links?',
    checked: state.shouldFilter,
    onChange: function onChange() {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          shouldFilter: !prev.shouldFilter
        });
      });
    }
  }, {
    id: 'hris-links',
    label: 'Show HRIS links?',
    checked: state.showHRISLinks,
    onChange: function onChange() {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          showHRISLinks: !prev.showHRISLinks
        });
      });
    }
  }];
  var setShowHRISLinks = function setShowHRISLinks(value) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        showHRISLinks: value
      });
    });
  };
  useEffect(function () {
    var _state = customSessionStorage.getItem('_CREH_CROSS_PLATFORM_NAVIGATION_DEBUGGER');
    if (_state) {
      try {
        setState(JSON.parse(_state));
      } catch (error) {
        console.error(error);
      }
    }
  }, []);
  var saveToLocalStorage = useCallback(function () {
    customSessionStorage.setItem('_CREH_CROSS_PLATFORM_NAVIGATION_DEBUGGER', JSON.stringify(state));
  }, [state]);
  useEffect(function () {
    saveToLocalStorage();
  }, [state, saveToLocalStorage]);
  var reset = function reset() {
    setState(initialState);
  };
  return /*#__PURE__*/_jsxs(DebuggerContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      setShowHRISLinks: setShowHRISLinks
    }),
    children: [children, !isProduction && /*#__PURE__*/_jsx("div", {
      className: "tw-fixed tw-top-2.4 tw-right-1.2 tw-z-dialog tw-transition-all tw-duration-300 tw-ease-in-out",
      style: {
        width: isExpanded ? '320px' : '40px',
        height: isExpanded ? 'auto' : '40px',
        overflow: 'hidden',
        borderRadius: '8px',
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        backdropFilter: 'blur(5px)'
      },
      onMouseEnter: function onMouseEnter() {
        return setIsExpanded(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsExpanded(false);
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "",
        children: isExpanded ? /*#__PURE__*/_jsxs("div", {
          className: "tw-p-4",
          children: [_h || (_h = /*#__PURE__*/_jsx("h2", {
            className: "tw-font-subtitle2 tw-mb-1.6 tw-text-neutral-light-800",
            children: "Sidebar menu options"
          })), /*#__PURE__*/_jsx("div", {
            className: "tw-mb-1.2",
            children: switchConfigs.map(function (config) {
              return /*#__PURE__*/_jsx("div", {
                className: "tw-mb-0.8",
                children: /*#__PURE__*/_jsx(Switch, {
                  id: config.id,
                  label: config.label,
                  showLabel: true,
                  color: "tw-neutral-light-100",
                  checked: config.checked,
                  onChange: config.onChange
                })
              }, config.id);
            })
          }), /*#__PURE__*/_jsx(Button, {
            variant: "delete",
            onClick: reset,
            type: "button",
            children: "Reset"
          })]
        }) : /*#__PURE__*/_jsx("div", {
          className: "tw-flex tw-items-center tw-justify-center tw-h-full",
          style: {
            background: 'rgba(0, 0, 0, 0.4)'
          },
          children: /*#__PURE__*/_jsx("p", {
            className: "tw-text-neutral-light-100 tw-font-semibold",
            style: {
              lineHeight: '40px'
            },
            children: "Dev"
          })
        })
      })
    })]
  });
};